// extracted by mini-css-extract-plugin
export default {"container":"page-shell_container__hXuG5","title":"page-shell_title__IZzOD","sub":"page-shell_sub__6cq9j"};